import { useState } from 'react';
import { IconButton } from '@zillow/constellation-10';
import { IconAttachmentOutline } from '@zillow/constellation-icons';
import { useCookies } from 'react-cookie';
import AttachmentGuidelines from '../modals/AttachmentGuidelines';
import AttachmentGuidelinesInline from '../modals/AttachmentGuidelinesInline';

const ATTACHMENT_GUIDELINES_MODAL_COOKIE = 'hasSeenAttachmentGuidelinesModal';

type Props = {
  isDisabled: boolean;
  setIsAttachmentsUploaderOpen: (value: boolean) => void;
  bordered?: boolean;
  /** Controls whether the attachment guidelines render as a dialog ('default') or inline overlay ('compact'). */
  guidelinesVariant?: 'default' | 'compact';
};

export default function AddAttachments({
  isDisabled,
  setIsAttachmentsUploaderOpen,
  bordered = false,
  guidelinesVariant = 'default',
}: Props) {
  const [cookies, setCookies] = useCookies([ATTACHMENT_GUIDELINES_MODAL_COOKIE]);
  const [isAttachmentGuidelinesOpen, setIsAttachmentGuidelinesOpen] = useState(false);
  const hasSeenAttachmentGuidelines = cookies[ATTACHMENT_GUIDELINES_MODAL_COOKIE];
  const isCompact = guidelinesVariant === 'compact';

  const openAttachmentsUploader = () => setIsAttachmentsUploaderOpen(true);

  const handleGuidelinesAcknowledge = () => {
    setCookies(ATTACHMENT_GUIDELINES_MODAL_COOKIE, 'true', {
      path: '/',
    });
    setIsAttachmentGuidelinesOpen(false);
    openAttachmentsUploader();
  };

  const handleAttachmentIconClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (hasSeenAttachmentGuidelines) {
      openAttachmentsUploader();
    } else {
      if (isCompact) {
        openAttachmentsUploader();
      }
      setIsAttachmentGuidelinesOpen(true);
    }
  };

  const guidelines =
    isAttachmentGuidelinesOpen &&
    (isCompact ? (
      <AttachmentGuidelinesInline onClose={handleGuidelinesAcknowledge} onContinue={handleGuidelinesAcknowledge} />
    ) : (
      <AttachmentGuidelines onClose={handleGuidelinesAcknowledge} />
    ));

  return (
    <>
      {guidelines}
      <IconButton
        icon={<IconAttachmentOutline />}
        disabled={isDisabled}
        emphasis="outlined"
        onClick={handleAttachmentIconClick}
        shape="circle"
        size="md"
        title="Attach files or images"
        tone="neutral"
        css={bordered ? undefined : { boxShadow: { lg: 'none' } }}
      />
    </>
  );
}
